var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"my-12",attrs:{"justify":"center"}},[_c('h1',[_vm._v("Sorry! This page is not available on the server.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }